import React, { useState, useContext } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import styled, { ThemeContext } from "styled-components";
import { addMobileClass } from "../../lib/utils";
import { getSelectedGuideCategory } from "./selectors";
import { categories, getIconForCategory } from "./utils";
import { switchCategory } from "./actions";

export const CategoriesBar = () => {
  const dispatch = useDispatch();
  const activeCategory = useSelector(getSelectedGuideCategory);
  const setActiveCategory = (newCategoryName) => {
    if (newCategoryName === activeCategory) {
      return;
    }
    dispatch(switchCategory(newCategoryName));
  };

  const theme = useContext(ThemeContext);

  return (
    <CategoriesWrapperDiv>
      {categories.map((cName) => {
        const Icon = getIconForCategory(cName);
        return (
          <CategoryDiv onClick={(e) => setActiveCategory(cName)} className={addMobileClass()} key={cName}>
            <Icon color={activeCategory === cName ? theme.brandColor : "#C2D6F1"} />
            <div className="category-name">{cName}</div>
          </CategoryDiv>
        );
      })}
    </CategoriesWrapperDiv>
  );
};

const CategoriesWrapperDiv = styled.div`
  position: absolute;
  left: calc(50% - 370px);
  top: 264px;
  z-index: 1;

  margin: 20px;
  height: fit-content;

  background-color: white;
  border-radius: 22px;
  box-shadow: 2px 4px 12px rgba(0, 0, 0, 0.12);

  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;

  user-select: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

const CategoryDiv = styled.div`
  display: inline-block;
  margin: 22px 11px 19px;

  text-align: center;
  cursor: pointer;

  flex: 0 0 auto;

  &:first-of-type {
    margin-left: 30px;
  }

  &:last-of-type {
    margin-right: 30px;
  }

  .category-name {
    font-size: 12px;
    line-height: 20px;
  }

  &.mobile {
    margin: 14px 6px 10px;

    &:first-of-type {
      margin-left: 14px;
    }

    &:last-of-type {
      margin-right: 14px;
    }

    .category-name {
      display: none;
    }
  }
`;
